(() => {
  const bindSlider = ({ stage, slides, dots, prev, next, interval = 5500 }) => {
    if (!stage || slides.length <= 1) return;

    let index = 0;
    let timer = null;

    const render = () => {
      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === index);
      });

      dots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === index;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
    };

    const goTo = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      render();
    };

    const stop = () => {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    };

    const start = () => {
      stop();
      timer = window.setInterval(() => {
        goTo(index + 1);
      }, interval);
    };

    prev?.addEventListener('click', () => {
      goTo(index - 1);
      start();
    });

    next?.addEventListener('click', () => {
      goTo(index + 1);
      start();
    });

    dots.forEach((dot, dotIndex) => {
      dot.addEventListener('click', () => {
        goTo(dotIndex);
        start();
      });
    });

    stage.addEventListener('mouseenter', stop);
    stage.addEventListener('mouseleave', start);
    stage.addEventListener('focusin', stop);
    stage.addEventListener('focusout', start);

    render();
    start();
  };

  const bindRail = (root, name) => {
    const viewport = root.querySelector(`[data-rail-viewport="${name}"]`);
    const prev = root.querySelector(`[data-rail-prev="${name}"]`);
    const next = root.querySelector(`[data-rail-next="${name}"]`);

    if (!viewport || !prev || !next) return;

    const update = () => {
      const maxScroll = Math.max(viewport.scrollWidth - viewport.clientWidth - 2, 0);
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxScroll;
    };

    const scrollByViewport = (direction) => {
      viewport.scrollBy({
        left: viewport.clientWidth * 0.92 * direction,
        behavior: 'smooth'
      });
    };

    prev.addEventListener('click', () => scrollByViewport(-1));
    next.addEventListener('click', () => scrollByViewport(1));
    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    update();
  };

  const init = (root) => {
    if (!root || root.dataset.cjHomepageBound === 'true') return;

    bindSlider({
      stage: root.querySelector('[data-hero-stage]'),
      slides: Array.from(root.querySelectorAll('[data-hero-slide]')),
      dots: Array.from(root.querySelectorAll('[data-hero-dot]')),
      interval: 6000
    });

    bindSlider({
      stage: root.querySelector('[data-testimonial-stage]'),
      slides: Array.from(root.querySelectorAll('[data-testimonial-index]')),
      dots: Array.from(root.querySelectorAll('[data-testimonial-dot]')),
      prev: root.querySelector('[data-testimonial-prev]'),
      next: root.querySelector('[data-testimonial-next]'),
      interval: 5500
    });

    bindRail(root, 'best-sellers');

    root.querySelectorAll('.cj-homepage__gram-video').forEach((video) => {
      const attemptPlay = () => {
        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      };

      attemptPlay();
      video.addEventListener('loadeddata', attemptPlay, { once: true });
    });

    root.dataset.cjHomepageBound = 'true';
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-cj-home-section]').forEach(init);
  };

  if (!window.CJHomepageSectionsInit) {
    window.CJHomepageSectionsInit = initAll;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAll(event.target);
    });
  } else {
    window.CJHomepageSectionsInit(document);
  }
})();
